module.exports = __webpack_public_path__ + "static/media/know-more.673de668.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/index/know-more.png
// module id = 221
// module chunks = 1